import styled from 'styled-components';

const CommentsPageLayout = styled.div`
  display: flex;
  height: 100%;
  overflow: hidden;

  .page-content {
    flex: 1;
    min-width: 0;
    overflow-y: auto;
  }

  .comments-panel {
    width: 480px;
    min-width: 480px;
    height: 100%;
    position: relative;
    overflow: hidden;

    > * {
      transform: translateX(100%);
      transition: transform 0.3s ease;
    }

    &.open > * {
      transform: translateX(0);
    }
  }
`;

export default CommentsPageLayout;
